export class PortalDebugMessage {
  public userGuid: string;
  public bxId: string;
  public messages: DebugMessage[];

  constructor(userGuid: string, bxId: string, messages: DebugMessage[] = []) {
    this.userGuid = userGuid;
    this.bxId = bxId;
    this.messages = messages;      
    for (const msg of this.messages) {
      if (typeof msg.message !== 'string') {
        msg.message = JSON.stringify(msg.message);
      }
      if (typeof msg.metadata !== 'string') {
        msg.metadata = JSON.stringify(msg.metadata);
      }
    }
  } 
}


export class DebugMessage {
  public id: string;
  public source: string;
  public type: string;
  public destination: string;
  public message: string;
  public metadata?: string;
  public timestamp: Date;

  constructor(id: string, source: string, destination: string, type: string, message: any, metaData: any, timestamp: Date = new Date()) {
    this.id = id;
    this.source = source;
    this.type = type;
    this.destination = destination;
    this.message = typeof message === 'string' ? message : (message === null || message === undefined ? '' : JSON.stringify(message));    
    this.metadata = typeof metaData === 'string' ? metaData : (metaData === null || metaData === undefined ? '' : JSON.stringify(metaData));    
    this.timestamp = timestamp;
  }   
} 
